import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getToken, getRefreshToken, getSolutionId, getExpires } from '@/utils/auth'
import { heartCheck } from '@/api/login'
// import zango from 'zangodb'
import i18n from '../lang' // Internationalization

function tokenTimer() {
  setInterval(() => {
    if (getToken()) {
      const expires = parseInt(getExpires())
      if (expires - parseInt(Date.now()) <= 10 * 60 * 1000) {
        const refresh = getRefreshToken()
        store.dispatch('refreshToken', { sid: getSolutionId(), refresh })
      } else {
        heartCheck()
      }
    }
  }, 5 * 60 * 1000)
}
tokenTimer()

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 50 * 1000, // 请求超时时间
  errorMessage: true
})
// request拦截器
service.interceptors.request.use(config => {
  config.params = { ...config.params } // , _t: Date.now() / 1000 | 0
  config.headers.post['Content-Type'] = 'application/json'
  config.headers.patch['Content-Type'] = 'application/json-patch+json'
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非20000是抛错 可结合自己业务进行修改
    */
    const status = response.status
    const message = response.statusText
    if (status < 200 || status > 300) {
      Message({
        message: message,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject('error')
    } else {
      return response
    }
  },
  error => {
    const errorMessage = error.response.config.errorMessage
    if (!errorMessage) return Promise.reject(error)
    // TODO 临时添加错误提示
    if (!(error.response.data instanceof Blob && error.response.status === 409)) {
      if (error.response) {
        if (error.response.status === 401) {
          window.onbeforeunload = () => { }
          Message({
            showClose: true,
            message: '登录失效！',
            type: 'error',
            duration: 2 * 1000
          })
        } else if (error.response.status === 404) {
          console.error('内容未找到')
          console.error(error)
          Message({
            showClose: true,
            message: i18n.t('alert.notFound'),
            type: 'error',
            duration: 2 * 1000
          })
        } else if (error.response.data) {
          Message({
            showClose: true,
            message: error.response.data.error || error.response.data,
            type: 'error',
            duration: 2 * 1000
          })
        } else {
          Message({
            showClose: true,
            message: i18n.t('login.error'),
            type: 'error',
            duration: 2 * 1000
          })
        }
      } else {
        Message({
          showClose: true,
          message: i18n.t('login.error'),
          type: 'error',
          duration: 2 * 1000
        })
      }
    }

    return Promise.reject(error)
  }
)

export default service
